import { all, fork, put, takeEvery, call } from "redux-saga/effects";
import { SagaIterator } from "@redux-saga/core";

// actions
import { enqApiResponseSuccess, enqApiResponseError, getEnq } from "./actions";

// constants
import { EnqActionTypes } from "./constants";
import { deleteEnqApi, getEnqApi } from "../../helpers/api/enquiry";

interface categoryData {
  payload: {
    id: number;
  };
  type: string;
}

function* getEnqq(): SagaIterator {
  try {
    const response = yield call(getEnqApi);

    const categoryData = response?.data;

    yield put(enqApiResponseSuccess(EnqActionTypes.GET_ENQ, categoryData));
  } catch (error: any) {
    yield put(enqApiResponseError(EnqActionTypes.GET_ENQ, error));
  }
}

function* deleteEnq({ payload: { id } }: categoryData): SagaIterator {
  try {
    const response = yield call(deleteEnqApi, id);
    const categoryData = response.data.message;
    // NOTE - You can change this according to response format from your api

    yield put(enqApiResponseSuccess(EnqActionTypes.DELETE_ENQ, categoryData));
    yield put(getEnq());
  } catch (error: any) {
    yield put(enqApiResponseError(EnqActionTypes.DELETE_ENQ, error));
  }
}

export function* watchGetEnq() {
  yield takeEvery(EnqActionTypes.GET_ENQ, getEnqq);
}

export function* watchDeleteEnq() {
  yield takeEvery(EnqActionTypes.DELETE_ENQ, deleteEnq);
}

function* enqSaga() {
  yield all([fork(watchDeleteEnq), fork(watchGetEnq)]);
}

export default enqSaga;
